import Repository from "./Repository";

export default {
  defaultModel(payload) {
    return Repository.post( "",payload);
  },
};
